import { isCheck24Url } from "@infrastructure/Helpers/UrlHelper";

export enum NavigationType {
    REPLACE,
    STACK,
    NEW,
}

export const useCommunityNavigation = () => {
    const navigateTo = (
        url: string,
        navType: NavigationType = NavigationType.STACK,
    ) => {
        if (window?.webkit?.messageHandlers?.dispatchUrl) {
            window.webkit.messageHandlers.dispatchUrl.postMessage(url);
        } else if (window?.NativeApp) {
            if (!isCheck24Url(url)) {
                window.open(url, "_blank");
            }
            window.NativeApp.dispatchUrlFromWebview?.(url);
        } else {
            if (navType === NavigationType.NEW || !isCheck24Url(url)) {
                window.open(url, "_blank");
            } else if (navType === NavigationType.STACK) {
                window.location.assign(url);
            } else {
                window.location.replace(url);
            }
        }
    };

    const decorateUrlWithLocalStorageTracking = (url: string) => {
        const linkoutURL = url.split("?")[0];

        const urlSearchParams = new URLSearchParams([
            ...Array.from(new URL(url).searchParams.entries()),
        ]);

        const urlSearchParamsString =
            urlSearchParams.toString().length > 0
                ? `?${urlSearchParams.toString()}`
                : "";

        return `${linkoutURL}${urlSearchParamsString}`;
    };

    return { navigateTo, decorateUrlWithLocalStorageTracking };
};
